import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { TOGGLZ_FEATURES } from '@bibliocommons/constants-feature-togglz';
import useFeature from 'app/hooks/useFeature';
import { EVENTS_URL } from 'app/constants/EventsConstants';

import './EventFeaturedImage.scss';

export default function EventFeaturedImage({ featuredImage, eventId }) {
  const isEventsV2DetailsPageEnabled = useFeature(TOGGLZ_FEATURES.EVENTS_V2_DETAILS_PAGE);
  const eventLink = isEventsV2DetailsPageEnabled ? `${EVENTS_URL}/${eventId}` : `/events/${eventId}`;

  return (
    featuredImage && (
      <div className="cp-event-featured-image">
        <a href={eventLink} tabIndex={-1} aria-hidden="true" data-key="event-image-link">
          <img src={featuredImage.get('url')} alt={featuredImage.get('alt')} loading="lazy" />
        </a>
      </div>
    )
  );
}

EventFeaturedImage.propTypes = {
  featuredImage: ImmutablePropTypes.map,
  eventId: PropTypes.string.isRequired
};
